export const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
export const LOGIN_PRODUCT_ID = process.env.REACT_APP_LOGIN_PRODUCT_ID;
export const LOGIN_TENANT_ID = process.env.REACT_APP_LOGIN_TENANT_ID;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const MDS_BASE_URL = process.env.REACT_APP_MDS_BASE_URL;
export const REQUEST_PRODUCT_ID = process.env.REACT_APP_REQUEST_PRODUCT_ID;
export const VALID_ROLE_IDS = [
  Number(process.env.REACT_APP_VALID_FISCUS_CASHIER_ROLE_ID),
  Number(process.env.REACT_APP_HEAD_CASHIER_ROLE_ID),
  Number(process.env.REACT_APP_SUB_CASHIER_ROLE_ID),
];
export const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const HEAD_CASHIER = process.env.REACT_APP_HEAD_CASHIER_ROLE_ID;
export const SUB_CASHIER = process.env.REACT_APP_SUB_CASHIER_ROLE_ID;
